<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate"
                  [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="nuevo()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          {{ DAT_TITULOS.nuevo }}
        </a>
        <a class="btn btn-outline-warning btn-outline"><i class="far fa-file-excel"></i></a>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #enviarTemplate>
  <br>
  <section class="section">
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
        </app-lfsa-alerts>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                         [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                         [pagination]="true"
                         [rowData]="rowData" [rowSelection]="rowSelection" [style]="modulo.agGrid.style"
                         class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion">
        </ag-grid-angular>
      </div>
    </div>
  </section>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row">
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('usuNombre')" [id]="'usuNombre'"
                        [label]="'Nombres*'" [placeholder]="'Ingrese Nombres'" [type]="'text'"
                        formControlName="usuNombre">
        </app-lfsa-input>
      </div>
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('usuEmail')" [id]="'usuEmail'"
                        [label]="'Email*'" [placeholder]="'Ingrese Email'" [type]="'email'"
                        formControlName="usuEmail">
        </app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('usuNick')" [id]="'usuNick'" [label]="'Nick*'"
                        [placeholder]="'Ingrese Nick'" [type]="'text'"
                        formControlName="usuNick"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('usuClave')" [id]="'usuClave'"
                        [label]="'Ingrese Clave*'" [placeholder]="'Clave'" [type]="'password'"
                        formControlName="usuClave">
        </app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbRoles" [control]="formulario.get('rol')"
                            [idOpcion]="'rolId'" [id]="'rol'" [label]="'Rol*'" [opcion]="'rolDescripcion'"
                            formControlName="rol"></app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbTipoUsuario" [control]="formulario.get('usuTipo')"
                            [idOpcion]="'clave'" [id]="'usuTipo'" [label]="'Tipo*'"
                            [opcion]="'valor'"
                            formControlName="usuTipo"></app-lfsa-combo-box>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" formControlName="usuRepdDiario" id="usuRepdDiario" type="checkbox">
          <label class="form-check-label" for="flexSwitchCheckDefault">Reporte Diario</label>
        </div>
      </div>
      <div class="form-group col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" formControlName="usuGestVta" id="usuGestVta" type="checkbox">
          <label class="form-check-label" for="flexSwitchCheckDefault">Gestion Venta</label>
        </div>
      </div>
      <div class="form-group col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" formControlName="usuStockmin" id="usuStockmin" type="checkbox">
          <label class="form-check-label" for="flexSwitchCheckDefault">Stock Minimo</label>
        </div>
      </div>
      <div class="form-group col-md-3">
        <div class="form-check form-switch">
          <input class="form-check-input" formControlName="usuFincotrato" id="usuFincotrato" type="checkbox">
          <label class="form-check-label" for="flexSwitchCheckDefault">Fin Contrato</label>
        </div>
      </div>
    </div>
    <br>
    <!-- {{ formulario.value | json }} -->
    <app-lfsa-botones-formulario (devolverAccion)="acciones ( $event )" [formularioValido]="formulario.invalid"
                                 [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </form>
</ng-template>


<app-lfsa-modal [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [idOpen]="'openModal'" [innTemplate]="enviarModal"
                [titulo]="'Asignar Clientes'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div class="row">
    <div class="col-md-6">
      <h4>Clientes</h4>
      <button (click)="saveAllClienteUsuario()" class="btn btn-success btn-block">Seleccionar Todo</button>
      <app-lfsa-alerts [listaVacia]="listaVaciaClientes" [loading]="loadingClientes" [texto]="DAT_TITULOS.listaVacia">
      </app-lfsa-alerts>
      <ag-grid-angular #agGrid (gridReady)="onGridReadyCliente($event)"
                       *ngIf="!listaVaciaClientes" [columnDefs]="columnDefsClientes"
                       [floatingFilter]="true" [frameworkComponents]="frameworkComponentsClientes " [localeText]="AG_GRID_LOCALE_ES"
                       [pagination]="true"
                       [rowData]="rowDataClientes" [rowSelection]="rowSelectionClientes"
                       [style]="modulo.agGridModal.style"
                       class="ag-theme-alpine" [paginationPageSize]="modulo.agGridModal.paginacion">
      </ag-grid-angular>
    </div>
    <div class="col-md-6">
      <h4>Clientes - Usuario: {{ this.usuarioSelected.usuNombre }}</h4>
      <button (click)="eliminarAllClienteUsuario()" class="btn btn-danger btn-block">Eliminar Todo</button>
      <app-lfsa-alerts [listaVacia]="listaVaciaCliUsuario" [loading]="loadingCliUsuario"
                       [texto]="DAT_TITULOS.listaVacia">
      </app-lfsa-alerts>
      <ag-grid-angular #agGrid (gridReady)="onGridReadyCliUsuario($event)"
                       *ngIf="!listaVaciaCliUsuario" [columnDefs]="columnDefsCliUsuario"
                       [floatingFilter]="true" [frameworkComponents]="frameworkComponentsCliUsuario " [localeText]="AG_GRID_LOCALE_ES"
                       [pagination]="true"
                       [rowData]="rowDataCliUsuario" [rowSelection]="rowSelectionCliUsuario"
                       [style]="modulo.agGridModal.style"
                       class="ag-theme-alpine" [paginationPageSize]="modulo.agGridModal.paginacion">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>
